import 'ol/ol.css';
import { Vector as VectorLayer } from 'ol/layer'
import { Vector as VectorSource } from 'ol/source'
import { Style, Stroke, Fill, Text, RegularShape } from 'ol/style';
import Point from "ol/geom/Point";
import Feature from 'ol/Feature.js';

export default class TooltipVectorLayer extends VectorLayer {
    constructor(map, options = {}) {
        const { lightMode = false } = options;
        
        const styleTooltip = new Style({
            text: new Text({
                font: "12px Calibri,sans-serif",
                fill: new Fill({
                    color: lightMode ? "rgba(51, 51, 51, 1)" : "rgba(255, 255, 255, 1)"
                }),
                backgroundFill: new Fill({
                    color: lightMode ? "rgba(255, 255, 255, 0.95)" : "rgba(0, 0, 0, 0.8)"
                }),
                backgroundStroke: new Stroke({
                    color: lightMode ? "rgba(0, 0, 0, 0.1)" : "rgba(255, 255, 255, 0.1)",
                    width: 1
                }),
                padding: [8, 12, 8, 12],
                textBaseline: "bottom",
                offsetY: -15
            }),
            image: new RegularShape({
                radius: 6,
                points: 3,
                angle: Math.PI,
                displacement: [0, 10],
                fill: new Fill({
                    color: lightMode ? "rgba(255, 255, 255, 0.95)" : "rgba(0, 0, 0, 0.8)"
                }),
                stroke: new Stroke({
                    color: lightMode ? "rgba(0, 0, 0, 0.1)" : "rgba(255, 255, 255, 0.1)",
                    width: 1
                })
            }),
            geometry: new Point([])
        });

        super({
            name: 'tooltip',
            source: new VectorSource({
            }),
            style: (feature) => this.styleFunction(feature),
            zIndex: 100
        });
        
        this.map = map;
        this.styleTooltip = styleTooltip;
        this.lightMode = lightMode;

        this.tooltipFeature = new Feature()
        this.getSource().addFeature(this.tooltipFeature);
    }

    styleFunction = function (feature) {
        const tooltipInfo = this.lastTooltipInfo;
        if (tooltipInfo) {
            this.styleTooltip.getGeometry().setCoordinates(tooltipInfo.coordinate);  
            this.styleTooltip.getText().setText(tooltipInfo.text);
            return this.styleTooltip
        }

        return undefined;
    };

    setTooltip = (coordinate, text, feature) => {
        if(this.lastTooltipInfo?.feature !== feature){
            this.tooltipFeature.setGeometry(feature.getGeometry().clone())
        }
        this.lastTooltipInfo = { feature, text, coordinate};
        this.tooltipFeature.set('coordinate', coordinate);
    }

    unsetTooltip = () => {
        this.lastTooltipInfo = undefined;
        this.tooltipFeature.unset('coordinate');
        this.tooltipFeature.setGeometry(undefined)    
    }
}